/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React from 'react';

import {connect} from 'react-redux';

import * as modalActions from '@/actions/modalActions';
import {showPopUp} from '@/actions/modalActions';
import HelpIcon from '@/assets/icons/Question.svg';
import Button from '@/components/button/Button';
import Profile from '@/components/profile/Profile';
import * as APPDATA from '@/constants/pcConstAppData';
import {newLineHtml} from '@/libs/htmlHelper';

import StatusManualControl, {MANUAL_CONTROL, SWITCH_TO_MANUAL_CONTROL} from './StatusManualControl';
import StatusText from './StatusText';

import '../StatusPage.less';

const ARRAY_ID_VOLUME_TO_START_AT = 3;
const ARRAY_ID_BUFFER_VOLUME_TO_USE = 4;
const HIDE_PROFILE_PREVIEW = 'Hide Profile Preview';

@connect((store) => ({
  currentPCState: store.setupStore.currentPCState,
  fontSize: store.setupStore.fontSize,
  manualControlStatus: store.manualControlStore.StatusManualControl,
  isPCRunning: store.setupStore.isPCRunning,
  isPCPaused: store.setupStore.isPCPaused,
  isManualControlEnable: store.manualControlStore.StatusManualControl.IsManualControlEnable === 'true',
  lockAccess: store.setupStore.lockAccess,
  profileRunning: store.setupStore.profileRunning,
}))
// TODO should differentiate the component name with .\PC.Client\ClientApp\Components\views\autoProfile\reusable\StatusProfile.js
class StatusProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lastRunningProfile: props.profileRunning,
      //   recordLastProfile: false,
      showProfile: props.profileRunning,
      hideProfileView: false,
      manualControlLabel: SWITCH_TO_MANUAL_CONTROL,
    };
    this._IsLastRunnigProfileRecorded = false;
  }

  componentDidMount() {
    if (this.props.isManualControlEnable) {
      this.setState({
        manualControlLabel: MANUAL_CONTROL,
      });
    }
    this._statusUpdater = setInterval(() => {
      this.statusProfile();
    }, APPDATA.CONFIGURATION.INTERVAL.STATUS_TIME_UPDATE);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.profileRunning.Id !== nextProps.profileRunning.Id) return true;
    if (this.props.isMobileView !== nextProps.isMobileView) return true;
    if (this.props.isManualControlEnable !== nextProps.isManualControlEnable) return true;
    if (this.props.isRemoteView !== nextProps.isRemoteView) return true;
    if (this.state.showProfile !== nextState.showProfile) return true;
    if (this.state.manualControlLabel !== nextState.manualControlLabel) return true;
    if (this.state.hideProfileView !== nextState.hideProfileView) return true;
    if (this.props.manualControlStatus.IsLastConcentration !== nextProps.manualControlStatus.IsLastConcentration)
      return true;
    if (this.props.manualControlStatus.IsManualControlEnable !== nextProps.manualControlStatus.IsManualControlEnable)
      return true;

    if (this.props.isPCRunning !== nextProps.isPCRunning) return true;
    if (this.props.isPCPaused !== nextProps.isPCPaused) return true;
    if (this.props.currentPCState !== nextProps.currentPCState) return true;
    if (this.props.lockAccess !== nextProps.lockAccess) return true;
    return false;
  }

  componentWillUnmount() {
    clearInterval(this._statusUpdater);
  }

  statusProfile = () => {
    const {profileRunning} = this.props;
    const IsProfileRunning = profileRunning.Id !== -1;
    if (IsProfileRunning === false) {
      if (this._IsLastRunnigProfileRecorded === true) {
        this.setState({
          showProfile: this.state.lastRunningProfile,
        });
        this._IsLastRunnigProfileRecorded = false;
        /// ConsoleLog ("Set show profile with last profile")
      }
    } else if (this._IsLastRunnigProfileRecorded === false) {
      this.setState({
        lastRunningProfile: this.props.profileRunning,
        showProfile: this.props.profileRunning, //
      });
      this._IsLastRunnigProfileRecorded = true;
      // ConsoleLog ("Set show profile with runnig profile")
    }
  };

  // eslint-disable-next-line class-methods-use-this
  profileView = (profileRunning) => {
    if (profileRunning === undefined) return null;
    if (profileRunning[APPDATA.KEY.Id] === -1) {
      const noProfile = (
        <div className="center">
          <Profile
            label="No Profile"
            profileNotFound
          />
        </div>
      );
      return noProfile;
    }
    const profileText = [
      {
        label: APPDATA.FIELD_NAME.STARTING_VOLUME,
        value: profileRunning[APPDATA.KEY.Config][APPDATA.KEY.StartingVolume],
        unit: APPDATA.UNIT.ml,
      },
      // {
      //     label : APPDATA.FIELD_NAME.STARTING_CONCENTRATION,
      //     value : profileRunning[APPDATA.KEY.Config][APPDATA.KEY.StartingConcentration],
      //     unit : APPDATA.UNIT.mg_per_ml
      // },
      {
        label: APPDATA.FIELD_NAME.FINAL_VOLUME,
        value: profileRunning[APPDATA.KEY.Config][APPDATA.KEY.FinalVolume],
        unit: APPDATA.UNIT.ml,
      },
      // {
      //     label : APPDATA.FIELD_NAME.FINAL_CONCENTRATION,
      //     value : profileRunning[APPDATA.KEY.Config][APPDATA.KEY.EstimatedFinalConcentration],
      //     unit : APPDATA.UNIT.mg_per_ml
      // },
      {
        label: APPDATA.FIELD_NAME.DIAFILTRATION,
        value: profileRunning[APPDATA.KEY.Config][APPDATA.KEY.DiafiltrationMode],
      },
      {
        label: APPDATA.FIELD_NAME.VOLUME_TO_START_AT_SORT,
        value: profileRunning[APPDATA.KEY.Config][APPDATA.KEY.VolumeToStartAt],
        unit: APPDATA.UNIT.ml,
      },
      {
        label: APPDATA.FIELD_NAME.BUFFER_VOLUME_TO_USE,
        value: profileRunning[APPDATA.KEY.Config][APPDATA.KEY.BufferVolumeToUse],
        unit: APPDATA.UNIT.ml,
      },
    ];
    if (profileRunning[APPDATA.KEY.Config][APPDATA.KEY.DiafiltrationMode] === APPDATA.FIELD_NAME.NONE_DIAFILTRATION) {
      delete profileText[ARRAY_ID_VOLUME_TO_START_AT];
      delete profileText[ARRAY_ID_BUFFER_VOLUME_TO_USE];
    }
    return <StatusText statusText={profileText} />;
  };

  manualControlPopUpAction = (e) => {
    switch (e.currentTarget.id) {
      case APPDATA.CONTINUE: {
        this.setState({manualControlLabel: MANUAL_CONTROL});
        const event = {
          currentTarget: {
            id: MANUAL_CONTROL,
          },
        };
        this.props.onClickManualControl(event);
        break;
      }
      case APPDATA.CANCEL:
        break;
      default:
        break;
    }
    this.props.dispatch(modalActions.hidePopUp());
  };

  onClick = (e) => {
    switch (e.currentTarget.id) {
      case HIDE_PROFILE_PREVIEW:
        this.setState({
          hideProfileView: !this.state.hideProfileView,
        });
        break;
      case MANUAL_CONTROL: {
        const manualControlButton = [
          {
            id: APPDATA.CONTINUE,
            isPrimaryButton: true,
            onClick: this.manualControlPopUpAction,
            label: APPDATA.CONTINUE,
          },
          {
            id: APPDATA.CANCEL,
            isPrimaryButton: false,
            onClick: this.manualControlPopUpAction,
            label: APPDATA.CANCEL,
          },
        ];

        const contentSplit = APPDATA.MESSAGES.MANUAL_CONTROL.TAP_HELP_BUTTON.split('{ICON}');
        this.props.dispatch(
          showPopUp({
            popUpTitle: APPDATA.MESSAGES.MANUAL_CONTROL.TITLE,
            popUpText: (
              <div className="center">
                {/* <span className="popUpTextCenter"> */}
                <span>
                  {newLineHtml(APPDATA.MESSAGES.MANUAL_CONTROL.POP_UP_BUTTON_SWITCH_MANUAL_CONTROL)}
                  {contentSplit.length === 2 ? (
                    <>
                      {contentSplit[0]}
                      {/* <img src={HelpIcon} disabled /> */}
                      <Button
                        id="helpIcon"
                        className="helpIcon"
                        icon={HelpIcon}
                        iconClassName="helpIconImg"
                        disabled
                      />
                      {contentSplit[1]}
                    </>
                  ) : null}
                </span>
              </div>
            ),
            popUpButton: manualControlButton,
          }),
        );
        break;
      }
      default:
        break;
    }
  };

  checkDisabelManualControl = () => {
    const {manualControlStatus, isPCRunning, isPCPaused, currentPCState, lockAccess} = this.props;

    let isDisableManualControlButton = true;
    if (lockAccess) isDisableManualControlButton = true;
    else if (isPCRunning === false || isPCPaused === true || currentPCState !== APPDATA.PC_CONCENTRATING_STATE)
      isDisableManualControlButton = true;
    else if (manualControlStatus.IsLastConcentration === 'true') {
      if (manualControlStatus.IsManualControlEnable === 'true') {
        // disable button when manual control is active
        isDisableManualControlButton = true;
      } else {
        isDisableManualControlButton = false;
      }
    } else {
      isDisableManualControlButton = true;
    }
    return isDisableManualControlButton;
  };

  generateStatusView = (hideProfileView, isManualControlEnable, showProfile, isMobileView, isRemoteView) => {
    let view;
    let showManualControl = false;
    if (isManualControlEnable) {
      if (isMobileView || isRemoteView) {
        showManualControl = false;
        view = <div className="row">{this.profileView(showProfile)}</div>;
      } else {
        showManualControl = true;
        //     view = <StatusManualControl
        //             showManualControl = {isManualControlEnable}
        //     />
      }
    } else {
      if (hideProfileView === false) view = <div className="row">{this.profileView(showProfile)}</div>;
      else view = <div />;

      showManualControl = false;
    }

    return (
      <div>
        {view}
        {/* Todo :Remove this, and move all event to global state */}
        <StatusManualControl showManualControl={showManualControl} />
      </div>
    );
  };

  render() {
    const {showProfile, manualControlLabel} = this.state;
    const {isMobileView, isManualControlEnable, isRemoteView} = this.props;

    const profilePreviewIcon = this.state.hideProfileView
      ? 'glyphicon glyphicon-eye-open'
      : '	glyphicon glyphicon-eye-close';
    const isDisableManualControlButton = this.checkDisabelManualControl();

    return (
      <>
        {!isMobileView && (
          <div className="row">
            <div className="row col-md-12 col-lg-12 profileControlBox middleAlign center ">
              <div className="col-md-12 col-lg-12 no-padding middleAlign ">
                <div className="col-md-1 col-lg-1 middleAlign no-padding">
                  <button
                    type="button"
                    id={HIDE_PROFILE_PREVIEW}
                    className={`hideShowProfile ${profilePreviewIcon}`}
                    onClick={this.onClick}
                    disabled={isManualControlEnable}
                  />
                </div>
                <div className="col-md-11 col-lg-11 no-padding middleAlign">
                  <div className="col-md-6 col-lg-6 profileName ">
                    <div className="profileNameText">{`${showProfile[APPDATA.KEY.Name]} Info`}</div>
                  </div>
                  {!isRemoteView && (
                    <div className="col-md-5 col-lg-5 no-padding">
                      <button
                        type="button"
                        id={MANUAL_CONTROL}
                        className="manual-control"
                        disabled={isDisableManualControlButton}
                        onClick={this.onClick}
                      >
                        {manualControlLabel}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
        {this.generateStatusView(
          this.state.hideProfileView,
          isManualControlEnable,
          showProfile,
          isMobileView,
          isRemoteView,
        )}
      </>
    );
  }
}
export default StatusProfile;
